import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { get_state, get_city } from "../../api/ControllApi";
import StarIcon from "@mui/icons-material/Star";

const MaterialStoreFilter = ({ onFilterChange, selectedState, selectedCity, selectedRating }) => {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    get_state().then((res) => setStates(res?.data || []));
  }, []);

  useEffect(() => {
    if (selectedState) {
      get_city({ state_id: selectedState }).then((res) => setCities(res?.data || []));
    } else {
      setCities([]);
    }
  }, [selectedState]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 380,
        py: 4,
        px: 3,
        mx: "auto",
        backgroundImage: `url("assets/images/plootbg.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 4,
        boxShadow: 3,
      }}
    >
      {/* HEADER */}
      <Typography fontWeight={600} fontSize={16} mb={1}>
        Filters
      </Typography>
      <Box sx={{ width: 120, height: 4, bgcolor: "#FEB821", mb: 3 }} />

      {/* STATE */}
      <FilterRow label="State">
        <TextField
          select
          fullWidth
          size="small"
          value={selectedState || ""}
          onChange={(e) => onFilterChange({ state: e.target.value, city: "" })}
          SelectProps={{
            displayEmpty: true,
            renderValue: (selected) => {
              if (!selected) {
                return (
                  <Typography sx={{ color: "#aaa", fontSize: 14 }}>
                    Select a state
                  </Typography>
                );
              }
              const found = states.find((s) => s.id === selected);
              return found ? found.state_name : selected;
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": { bgcolor: "#fff" },
          }}
        >
          <MenuItem value="">
            <em style={{ color: "#aaa" }}>All States</em>
          </MenuItem>
          {states.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.state_name}
            </MenuItem>
          ))}
        </TextField>
      </FilterRow>

      {/* CITY */}
      <FilterRow label="City">
        <TextField
          select
          fullWidth
          size="small"
          value={selectedCity || ""}
          onChange={(e) =>
            onFilterChange({ state: selectedState, city: e.target.value })
          }
          disabled={!selectedState}
          SelectProps={{
            displayEmpty: true,
            renderValue: (selected) => {
              if (!selected) {
                return (
                  <Typography sx={{ color: "#aaa", fontSize: 14 }}>
                    {!selectedState ? "Select a state first" : "Select a city"}
                  </Typography>
                );
              }
              const found = cities.find((c) => c.id === selected);
              return found ? found.city_name : selected;
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              bgcolor: "#fff",
              "&.Mui-disabled": { bgcolor: "rgba(255,255,255,0.5)" },
            },
          }}
        >
          <MenuItem value="">
            <em style={{ color: "#aaa" }}>All Cities</em>
          </MenuItem>
          {cities.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.city_name}
            </MenuItem>
          ))}
        </TextField>
      </FilterRow>

      {/* RATING */}
      <FilterRow label="Rating"
      // icon={<StarIcon sx={{ fontSize: 20, color: "#FEB821", mr: 1 }} />}
      >
        <TextField
          select
          fullWidth
          size="small"
          value={selectedRating || ""}
          onChange={(e) => onFilterChange({ state: selectedState, city: selectedCity, rating: e.target.value })}
          SelectProps={{
            displayEmpty: true,
            renderValue: (selected) => {
              if (!selected) {
                return (
                  <Typography sx={{ color: "#aaa", fontSize: 14 }}>
                    Select Rating
                  </Typography>
                );
              }
              return `${selected} Stars`;
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": { bgcolor: "#fff" },
          }}
        >
          <MenuItem value="">
            <em style={{ color: "#aaa" }}>All Ratings</em>
          </MenuItem>
          {[5, 4, 3, 2, 1].map((rating) => (
            <MenuItem key={rating} value={rating}>
              {rating} Stars
            </MenuItem>
          ))}
        </TextField>
      </FilterRow>

      <Button
        fullWidth
        variant="outlined"
        sx={{
          mt: 2,
          textTransform: "none",
          backgroundColor: "#82A240",
          color: "white",
          // borderColor: "green",
          
                "&:hover": { background: "#6A8A35" },
        }}
        onClick={() => onFilterChange({ state: "", city: "", rating: "" })}
      >
        Clear Filters
      </Button>
    </Box>
  );
};

const FilterRow = ({ label, children, icon }) => (
  <Box sx={{ mb: 3 }}>
    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
      {icon}
      <Typography variant="subtitle2">{label}</Typography>
    </Box>
    {children}
  </Box>
);

export default MaterialStoreFilter;